
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 12 7"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#999","d":"M10.336.6L6 4.937 1.663.6a.75.75 0 00-1.06 1.06l4.865 4.865c.146.147.34.22.532.219a.748.748 0 00.532-.219l4.865-4.865A.75.75 0 0010.337.6z"}})])
          )
        }
      }
    